module.exports = __webpack_public_path__ + "img/request.aaf5a254.svg";